import {routeTo} from '@/utils/router'
import {Service} from '@/utils/service-request/types'
import {supportedServices} from '@/utils/supported-services/supported-services'

export const useServiceCommonContent = () => ({
  header: {
    buttonLinkText: 'legal-services-common-header-main-cta',
  },
  selectServiceButton: 'service-selection-placeholder',
  requestQuoteButton: 'button-request-quote',
  showPriceListButton: 'button-show-price-list',
  priceTitle: 'price-title',
  finalPriceDescription: 'legal-service-final-pricing-desc',
  teamSubtitle: 'legal-services-team-description',
  pricingTable: {
    serviceKey: supportedServices.Legal,
    title: 'legal-services-pricing-title',
    subtitle: 'legal-services-pricing-desc',
    simpleServicesTitle: 'legal-services-simple-title',
    complexServicesTitle: 'legal-services-complex-title',
  },
  pricingBanner: {
    title: 'pricing-for-standard-case-title',
    description: 'pricing-for-standard-case-description',
    imageSrc: '/images/hero/ice-cream-with-price-tag.svg',
    imageAlt: 'Ice cream with a price tag',
  },
  ipCases: {
    title: 'learn-more-about-ip-cases-title',
    buttonLinkText: 'button-view-ip-cases-database',
    buttonLinkHref: routeTo.trademarkDisputes.home(),
  },
  faqs: {
    title: 'frequently-asked-questions-title',
    imageSrc: '/images/light-bulb-with-r.svg',
    imageAlt: 'Light bulb with R',
  },
  form: {
    title: 'legal-services-form-title',
    saveTrademarkTitle: 'save-trademark-together-form-title',
    protectBrandTitle: 'protect-brand-together-form-title',
    protectTrademarkTitle: 'protect-trademark-together-form-title',
    description: 'legal-services-form-description',
    imageSrc: '/images/advice-2.svg',
    imageAlt: 'Advice',
    messagePlaceholder: 'legal-services-form-message-placeholder',
    buttonText: 'button-request-quote',
    fileUpload: {
      label: 'form-screenshots-and-other-files-label',
      supportedFormatsNote: 'form-screenshots-and-other-files-supported-formats',
    },
    offeredServices: [
      Service.tmRegistration,
      Service.tmStrategy,
      Service.tmRepresentation,
      Service.officeAction,
      Service.responseToObjection,
      Service.cdLetterResponse,
      Service.coexistenceAgreement,
      Service.gsLimitation,
      Service.tmRenewal,
      Service.tmAssignmentAgreement,
      Service.statementOfUse,
      Service.declarationOfUse,
      Service.declarationOfIncontestability,
      Service.filingOpposition,
      Service.cdLetter,
      Service.enforcementOfRights,
      Service.tmAssignment,
      Service.tmSettlement,
      Service.brandMonitoring,
      Service.infringementTakedown,
    ] as string[],
  },
})
